import { KYMW0800OutputModel } from './../../../../commons/kymw08/kymw0800/vo/kymw0800-output.model';
import { Component, ViewEncapsulation, OnInit, Input, ViewChild, ElementRef, ComponentRef, ViewContainerRef } from '@angular/core';
import { KYMW00Model } from '../../../../commons/kymw00/kymw00.model';
import { KYMW1300SelectTargetTabModel } from '../vo/kymw1300-select-target-tab.model';
import { PlessViewHelperSub } from '../../../../commons/kymw00/pless-view-helper-sub';
import { KYMW1300Model } from '../kymw1300.model';
import { OrderNumQuotaCodeComboBoxComponent } from '../../../../commons/kymw02/combo-box/order-num-quota-code-combo-box/order-num-quota-code-combo-box.component';
import { FlexGrid, CellType, CellRange } from '@grapecity/wijmo.grid';
import { ClassCodeComboBoxComponent } from '../../../../commons/kymw02/combo-box/class-code-combo-box/class-code-combo-box.component';
import { GetPlanTargetListService } from '../api-services/get-plan-target-list.service';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { KYMW0300InputModel } from '../../../../commons/kymw03/kymw0300/vo/kymw0300-input.model';
import { KYMW0300OutputModel } from '../../../../commons/kymw03/kymw0300/vo/kymw0300-output.model';
import { KYMW0300Component } from '../../../../commons/kymw03/kymw0300/kymw0300.component';
import { KYMW0800InputModel } from '../../../../commons/kymw08/kymw0800/vo/kymw0800-input.model';
import { KYMW1300RegistPlanModel } from '../vo/kymw1300-regist-plan.model';
import { CheckRegistPlanService } from '../api-services/check-regist-plan.service';
import { KYMW1300GetSearchSelectedListModel } from '../vo/kymw1300-get-search-selected-list.model';
import { GetSelectedListService } from '../api-services/get-selected-list.service';
import { GetOrderNumQuotaDataService } from '../api-services/get-order-num-quota-data.service';
import { Menu } from '@grapecity/wijmo.input';
import { KYMW0800Component } from '../../../../commons/kymw08/kymw0800/kymw0800.component';
import { DataGridUtil } from '../../../../commons/kymw00/data-grid-util';
import { PlanGoodsLockService } from '../../../../commons/kymw00/api-services/plan-goods-lock.service';
import { SmallClassCodeComboBoxComponent } from '../../../../commons/kymw02/combo-box/small-class-code-combo-box/small-class-code-combo-box.component';
import { MiddleClassCodeComboBoxComponent } from '../../../../commons/kymw02/combo-box/middle-class-code-combo-box/middle-class-code-combo-box.component';
import { faArrowAltCircleLeft, faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
import { PagerComponent } from 'src/app/commons/kymw02/pager/pager.component';
import { RadioLabelComponent } from 'src/app/commons/kymw02/radio-label/radio-label.component';
import { KYMW1300CheckRegistPlanModel } from '../vo/kymw1300-check-regist-plan.model';
import { KYMW1300GetPlanTargetListModel } from '../vo/kymw1300-get-plan-target-list.model';
import { PlanTargetList } from '../vo/plan-target-list.model';
import { GetDeletePlanGoodsInfoService } from '../../kymw1318/api-services/get-delete-plan-goods-info';
import { GetDeletePlanGoodsInfoModel } from '../../kymw1318/vo/kymw1318-get-delete-plan-goods-info.model';
import { GetFeatureCodeListService } from '../api-services/get-feature-code-list.service';
import { GetBundleCatalogRoundInfoListService } from '../api-services/get-bundle-catalog-round-info-list.service';

/**
 * 商品企画マスタ画面　選定候補一覧を管理するクラス
 *
 * @export KYMW1300Component
 * @class KYMW1300Component
 */
@Component({
  selector: 'app-kymw1300-target-list',
  templateUrl: 'kymw1300-target-list.component.html',
  styleUrls: ['kymw1300-target-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1300TargetListComponent extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  @Input() parentModel: KYMW1300Model = null;

  // 画面部品参照
  @ViewChild('cmb_OrderNumQuota', { static: true }) cmb_OrderNumQuota: OrderNumQuotaCodeComboBoxComponent;

  @ViewChild('ckb_DealEnableCoopIB_Target1', { static: true }) ckb_DealEnableCoopIB_Target1: ElementRef;
  @ViewChild('ckb_DealEnableCoopIB_Target2', { static: true }) ckb_DealEnableCoopIB_Target2: ElementRef;
  @ViewChild('ckb_DealEnableCoopIB_Target3', { static: true }) ckb_DealEnableCoopIB_Target3: ElementRef;

  @ViewChild('cmb_ClassCode_Standard', { static: true }) cmb_ClassCode_Standard: ClassCodeComboBoxComponent;

  @ViewChild('cmb_ClassCode_Catalog', { static: true }) cmb_ClassCode_Catalog: ClassCodeComboBoxComponent;
  @ViewChild('cmb_MiddleClassCode_Catalog', { static: true }) cmb_MiddleClassCode_Catalog: MiddleClassCodeComboBoxComponent;
  @ViewChild('cmb_SmallClassCode_Catalog', { static: true }) cmb_SmallClassCode_Catalog: SmallClassCodeComboBoxComponent;
  @ViewChild('cmb_InnerOrderNumQuota', { static: true }) cmb_InnerOrderNumQuota: ElementRef;

  @ViewChild('dg_SelectTargetList', { static: true }) dg_SelectTargetList: FlexGrid;

  // 各ページャーコントローラ
  @ViewChild('standardPager', { static: true }) standardPager: PagerComponent;
  @ViewChild('catalogPager', { static: true }) catalogPager: PagerComponent;
  @ViewChild('targetSet1Pager', { static: true }) targetSet1Pager: PagerComponent;
  @ViewChild('targetSet2Pager', { static: true }) targetSet2Pager: PagerComponent;
  @ViewChild('targetSet3Pager', { static: true }) targetSet3Pager: PagerComponent;

  @ViewChild('box_target_list', { static: true }) box_target_list: ElementRef;

  // 束ね企画回、単企画回ラジオボタン
  @ViewChild('rbtn_selectBundleCatalogRound', { static: true }) rbtn_selectBundleCatalogRound: RadioLabelComponent;
  @ViewChild('rbtn_selectSingleBundleCatalogRound', { static: true }) rbtn_selectSingleBundleCatalogRound: RadioLabelComponent;

  /**
   * 選定候補一覧
   */
  public targetSetModel: KYMW1300SelectTargetTabModel = new KYMW1300SelectTargetTabModel();

  // コンテキストメニュー
  private cmDgKYMW1300_02: Menu;

  public selectElement: any = <any>'';

  /**
   * 選定候補一覧 項目名
   * DataGridの列名とテーブル物理名を紐付ける連想配列Object
   */
  private selectTargetListField: Object;

  // 画面部品参照
  private kymw0300ComponentRef: ComponentRef<any> = null;
  private kymw0300Component: KYMW0300Component = null;

  // ページング
  iconPrev = faArrowAltCircleLeft;
  iconNext = faArrowAltCircleRight;

  /**
   * Creates an instance of KYMW1300TargetListComponent.
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1300SelectTargetTabModel
   */
  constructor(
    private elementRef: ElementRef,
    public viewContainerRef: ViewContainerRef,
    kymw00Model: KYMW00Model,
    private dialogService: PlessDialogServiceSub,
    private checkRegistPlanService: CheckRegistPlanService,
    private getPlanTargetListService: GetPlanTargetListService,
    private getSelectedListService: GetSelectedListService,
    private planGoodsLockServiceSub: PlanGoodsLockService,
    private getDeletePlanGoodsInfoService: GetDeletePlanGoodsInfoService,
    private getFeatureCodeListService: GetFeatureCodeListService,
    private getBundleCatalogRoundInfoListService: GetBundleCatalogRoundInfoListService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1300TargetListComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1300TargetList';
    this.planGoodsLockService = this.planGoodsLockServiceSub;

    // 選定候補一覧 項目名を初期化
    this.selectTargetListField = new Object();
    this.selectTargetListField['ClassCode'] = 'CLASS_CODE';
    this.selectTargetListField['SmallClassCode'] = 'SMALL_CLASS_CODE';
    this.selectTargetListField['GuideGoodsName'] = 'GUIDE_GOODS_NAME';
    this.selectTargetListField['GuideStandardName'] = 'GUIDE_STANDARD_NAME';
    this.selectTargetListField['PCode'] = 'PCODE';
    this.selectTargetListField['JustBeforeCatalogId'] = 'JUST_BEFORE_CATALOG_ID';
    this.selectTargetListField['AssortTempName'] = 'ASSORT_TEMP_NAME';
    this.selectTargetListField['RelateMasterCode'] = 'RELATE_MASTER_CODE';
    this.selectTargetListField['NextCatalog'] = 'NEXT_CATALOG';
    this.selectTargetListField['BuyerCode'] = 'BUYER_CODE';

    // コンテキストメニュー初期化
    this.setContextMenu();

    this.dg_SelectTargetList.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dg_SelectTargetList.select(-1, -1);

      // データグリッド行の背景色設定処理
      this.setColorPattern(this.dg_SelectTargetList);
    });

    this.targetSetModel.kymw1300Component = this.parentModel.kymw1300Component;
    this.targetSetModel.kymw1300_02Cmp = this;

  }

  /**
   * コンテキストメニュー初期化
   *
   * @private
   * @memberof KYMW1300TargetListComponent
   */
  private setContextMenu(): void {

    const item_1: any = { header: '選定', caption: '選定', cmd: 'REGIST_PLAN', enabled: true };
    const item_2: any = { header: '選定済リストを検索', caption: '選定済リストを検索', cmd: 'SEARCH_SELECTED_LIST', enabled: true };
    const item_3: any = { header: '履歴', caption: '履歴', cmd: 'KYMW0800', enabled: true };

    this.cmDgKYMW1300_02 = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          item_1,
          { caption: '-' },
          item_2,
          { caption: '-' },
          item_3,
        ],
        command: this.getFormatMenuCommand(),
        // イベント設定
        itemClicked: () => {
          switch (this.cmDgKYMW1300_02.selectedValue) {
            case 'REGIST_PLAN':                                                 // 選定
              if (!this.eventRegistPlan_CLICKHandler()) {
                return;
              }
              break;
            case 'SEARCH_SELECTED_LIST':                                        // 選定済リストを検索
              this.eventSearchSelectedList_CLICKHandler();
              break;
            case 'KYMW0800':                                                    // 履歴
              this.eventKYMW0800_CLICKHandler();
              break;
          }
        }
      }
    );

    // 選定候補一覧・定番　右クリック押下時 コンテキストメニュー表示処理
    this.dg_SelectTargetList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.cmDgKYMW1300_02 !== undefined) {
        const ht = this.dg_SelectTargetList.hitTest(e.pageX, e.pageY);
        if (ht.cellType === CellType.Cell) {
          // 選択した行がすでに選択されていない行の場合はその行を選択（既に選択されている行はクリア）
          const alreadySelectedRow = this.dg_SelectTargetList.selectedRows.filter(row => row.index === ht.row);
          if (PlessViewUtilsSub.isEmptyArray(alreadySelectedRow)) {
            // 右クリック押下時に対象行を選択状態にする
            const grid = new CellRange(ht.row, ht.col);
            this.dg_SelectTargetList.select(grid, false);
          }
          // コンテキストメニューの活性非活性制御
          this.eventContextMenu_MENUSELECTHandler(e, this.cmDgKYMW1300_02);
          this.cmDgKYMW1300_02.show(e);
        } else {
          // コンテキストメニュー活性・非活性制御
          this.cmDgKYMW1300_02.itemsSource.forEach(item => {
            item.enabled = false;
          });
          this.cmDgKYMW1300_02.show(e);
        }
      }
    });

    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode(item_1, 'false');      // 選定
    this.initForcedEnabledForContextMenuItemByScreenMode(item_2, 'none');       // 選定済リストを検索
    this.initForcedEnabledForContextMenuItemByScreenMode(item_3, 'none');       // 履歴
  }

  /**
   * コンテキストメニュー活性・非活性制御
   *
   * @private
   * @param {any} event
   * @param {Menu} contextMenu
   * @returns {void}
   * @memberof KYMW1300TargetListComponent
   */
  // public eventContextMenu_MENUSELECTHandler(contextMenu: Menu): void {
  public eventContextMenu_MENUSELECTHandler(event: any, contextMenu: Menu): void {
    let grid: FlexGrid = null;
    let enableFlag = Boolean(true);
    let rowIndex = Number(0);
    let status: string = null;

    grid = this.dg_SelectTargetList;
    rowIndex = this.dg_SelectTargetList.hitTest(event).row;
    if (rowIndex > -1) {
      status = this.targetSetModel.selectTargetList[rowIndex].Status;
    }

    // 選択行のチェック
    if (grid === null || grid.selection.row === -1) {                           // 選択行なしの場合
      // コンテキストメニュー活性・非活性制御
      contextMenu.itemsSource.forEach(item => {
        item.enabled = this.setContextMenuEnabled(item, false);
      });

      // 処理復帰
      return;
    }

    contextMenu.itemsSource.forEach(item => {
      enableFlag = true;

      if (item.caption === '選定') {
        const mediumType: string = this.parentModel.mediumType;
        const sellAreaCode: string = this.parentModel.kymw1300Component.cmb_SellArea.selectedSellAreaCode;

        // 編集ロック、媒体区分、売場区分のチェック
        if (this.parentModel.editLock === false ||                              // 「false：閲覧モード」、
          PlessViewUtilsSub.isEmpty(mediumType) ||                              // 未選択、
          PlessViewUtilsSub.isEmpty(sellAreaCode)) {                            // 未選択の場合
          enableFlag = false;
        }

        // 束ねフラグが'1'の媒体が選択されていて、かつ束ね企画名が未選択の場合使用不可(非活性)にする
        const selectedMediumTypeList = this.parentModel.mediumTypeList.find(item => item.MediumType === this.parentModel.mediumType);
        if (selectedMediumTypeList.BundleCatalogFlag === '1' && PlessViewUtilsSub.isEmpty(this.parentModel.bundleCatalogGuideStandardName)) {
          enableFlag = false;
        }

        // 選択したデータの状態が「他（同一媒体グループで選定済み）」かつ、媒体グループ区分が「02」ではない場合、使用不可にする
        if (status === '3' && selectedMediumTypeList.MediumGroupDiv !== '02') {
          enableFlag = false;
        }
      } else if (item.caption === '選定済リストを検索') {
        // 選定, 他媒体で選定以外の場合 非活性
        if (status !== '2' && status !== '3') {                                 // 「2：自媒体で選定」、「3：他媒体で選定」以外の場合
          enableFlag = false;
        }
      }

      // コンテキストメニュー活性・非活性制御
      item.enabled = this.setContextMenuEnabled(item, enableFlag);
    });
  }

  private getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param: any) => {
        // 各項目の活性制御
        if (param.enabled === false) {
          return false;
        } else {
          return true;
        }
      }
    };
  }

  /**
   * データグリッド行の背景色設定
   *
   * @param {FlexGrid} grid 処理対象データグリッド
   * @memberof KYMW1300TargetListComponent
   */
  public setColorPattern(grid: FlexGrid): void {

    // 背景色設定
    grid.rows.forEach((row) => {
      // 状態のチェック(0：通常、1：仮登録、2：自媒体選定、3：他媒体選定、9：取扱期間外)
      if (row.dataItem.Status === '1') {                                     // 「1：仮登録」の場合
        if (row.isSelected) {
          row.cssClass = '';
        } else {
          row.cssClass = 'grid-row-temporary-registration';
        }
      } else if (row.dataItem.Status === '2') {                              // 「2：自媒体選定」の場合
        if (row.isSelected) {
          row.cssClass = '';
        } else {
          row.cssClass = 'grid-row-own-medium';
        }
      } else if (row.dataItem.Status === '3') {                              // 「3：同一グループで選定」の場合
        if (row.isSelected) {
          row.cssClass = '';
        } else {
          row.cssClass = 'grid-row-same-group';
        }
      } else if (row.dataItem.Status === '4') {                              // 「4：別グループで選定」の場合
        if (row.isSelected) {
          row.cssClass = '';
        } else {
          row.cssClass = 'grid-row-other-group';
        }
      } else if (row.dataItem.Status === '9') {                              // 「9：取扱期間外」の場合
        if (row.isSelected) {
          row.cssClass = '';
        } else {
          row.cssClass = 'grid-row-outside-handling-period';
        }
      }
    });
  }

  /**
   * 選定候補一覧　束ね企画回への選定/単企画回への選定ラジオボタン_変更時に呼び出されるメソッド
   */
  public eventSelectBundleCatalogRoundHandler(): void {
    // 「単企画回への選定」にチェックが入った場合、受注コードは必須項目となる
    if (this.parentModel.radioGroup === '1') {
      this.parentModel.kymw1300Component.txt_OrderCode.required = false;     // 受注コードの背景を白色
    } else {
      this.parentModel.kymw1300Component.txt_OrderCode.required = true;      // 受注コードの背景を黄色
    }
  }

  /**
   * 商品検索(ボタン)_クリック時に呼び出される
   *
   * @memberof KYMW1300TargetListComponent
   */
  public eventKYMW0300_CLICKHandler(): void {
    // 『商品検索』画面を呼び出す
    let kymw0300vo: KYMW0300InputModel = new KYMW0300InputModel();
    kymw0300vo = this.setKYMW0300InputVO(this.targetSetModel);
    if ((PlessViewUtilsSub.isEmpty(this.parentModel.orderCode)) && (PlessViewUtilsSub.isEmpty(this.parentModel.bundleCatalogGuideStandardName))) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード、束ね企画名どちらか'], () => { });
    } else {
      // 商品検索画面(モーダル)を表示する。
      const componentRef = this.dialogService.openModal(KYMW0300Component);
      const instance = componentRef.componentInstance as KYMW0300Component;
      instance.parent = this;
      instance.setInterfaceParam(kymw0300vo);
      instance.setKYMW0300Parameter = (outputVO: KYMW0300OutputModel) => this.parentModel.kymw1300Component.setKYMW0300Parameter(outputVO);

      instance.closeFunction = ()=>{
        componentRef.close();
      }
    }
  }

  /**
   * 商品検索画面InputVO初期化
   *
   * @param {KYMW1300SelectTargetTabModel} model 検索結果表示対象候補セットタブモデル
   * @returns {KYMW0300InputModel}
   * @memberof KYMW1300Model
   */
  public setKYMW0300InputVO(model: KYMW1300SelectTargetTabModel): KYMW0300InputModel {

    const returnVO: KYMW0300InputModel = new KYMW0300InputModel();

    // 検索条件保持
    // 候補セットタブモデルのインスタンスチェック
    if (model !== null) {                                                       // 指定ありの場合
      returnVO.pcode = model.pcode;
      returnVO.itemCode = model.itemCode;
      returnVO.janCode = model.janCode;
      returnVO.makerName = model.makerName;
      returnVO.guideGoodsNameList = model.guideGoodsNameList;
      returnVO.guideStandardNameList = model.guideStandardNameList;
      returnVO.tagId = model.tagId;
      returnVO.tagSearchType = model.tagSearchType;
      returnVO.goodsMark = model.goodsMark;
      returnVO.goodsMarkSearchType = model.goodsMarkSearchType;
      returnVO.dataKbnFlg = model.dataKbnFlg;
      returnVO.goodsDiv = model.goodsDiv;
      returnVO.coopCodeList = model.coopCode;
      returnVO.buyerCode = model.buyerCode;
      returnVO.admitStatus = model.admitStatus !== null ? model.admitStatus : '';
      returnVO.registDateFrom = model.registDateFrom;
      returnVO.registDateTo = model.registDateTo;
      returnVO.updateDateFrom = model.updateDateFrom;
      returnVO.updateDateTo = model.updateDateTo;
      returnVO.classCode = model.classCode;
      returnVO.middleClassCode = model.middleClassCode;
      returnVO.smallClassCode = model.smallClassCode;
      returnVO.ordrClientCode = model.ordrClientCode;
      returnVO.ordrClientKanji = model.ordrClientKanji;
      returnVO.payeeClientCode = model.payeeClientCode;
      returnVO.payeeClientKanji = model.payeeClientKanji;
      returnVO.mediumType = model.searchMediumType;
      returnVO.orderCode = model.searchOrderCode;
      returnVO.specialFeature = model.specialFeature;
      returnVO.catalogCode = model.catalogCode;
      returnVO.catalogCodeSearchType = model.catalogCodeSearchType;
      returnVO.pageNo = model.pageNo;
      returnVO.duties = model.duties;
      returnVO.pcodeList = model.pcodeList;
      returnVO.itemCodeList = model.itemCodeList;
      returnVO.searchKbn = model.searchKbn;
      // 企画関連条件を表示する（企画検索フラグ:1）
      returnVO.catalogSearchFlg = 1;
      // 検索条件設定画面で再表示用
      returnVO.tagOutput = model.tagOutput;
      returnVO.goodsMarkOutput = model.goodsMarkOutput;
      returnVO.catalogId = model.catalogId;
      returnVO.catalogMarkOutput = model.catalogMarkOutput;
      returnVO.pageInput = model.pageInput;
    }

    // 商品検索画面InputVOを返却
    return returnVO;
  }


  /**
   * 選定候補一覧　前へ／次へ(ボタン)_クリック時に呼び出されるメソッド
   *
   * @param {number} [focusFlg=0] フォーカスフラグ(1：前へボタン、2：次へボタン)
   * @returns {void}
   * @memberof KYMW1300TargetListComponent
   */
  public eventDisplay_CLICKHandler(focusFlg = 0): void {
    let getPlanTargetListVO: KYMW1300GetPlanTargetListModel = null;

    // ヘッダー情報入力チェック(媒体：チェック否、売り場：チェック否)
    if (!this.parentModel.kymw1300Component.checkInputHeader()) {               // チェックエラーの場合ok
      return;
    }

    // 02. 選定候補一覧取得APIリクエストVO初期化処理
    switch (focusFlg) {
      case 1:                                                                   // 「1：前へボタン」の場合
        getPlanTargetListVO = this.parentModel.setGetPlanTargetListVO(this.targetSetModel, null, Boolean(true));
        getPlanTargetListVO.page = String(Number(getPlanTargetListVO.page) - 1);
        getPlanTargetListVO.focusFlg = '1';
        break;
      case 2:                                                                   // 「2：次へボタン」の場合
        getPlanTargetListVO = this.parentModel.setGetPlanTargetListVO(this.targetSetModel, null, Boolean(true));
        getPlanTargetListVO.page = String(Number(getPlanTargetListVO.page) + 1);
        getPlanTargetListVO.focusFlg = '2';
        break;
      default:
        return;
    }
    const planTargetList: PlanTargetList = [
      {
        guideGoodsName: getPlanTargetListVO.guideGoodsName as Array<string>,
        guideStandardName: getPlanTargetListVO.guideStandardName as Array<string>,
        tagId: getPlanTargetListVO.tagId as Array<string>,
        goodsMark: getPlanTargetListVO.goodsMark as Array<string>,
        coopCode: getPlanTargetListVO.coopCode as Array<string>,
        catalogCode: getPlanTargetListVO.catalogCode as Array<string>,
        pageNo: getPlanTargetListVO.pageNo as Array<string>,
        duties: getPlanTargetListVO.duties as Array<string>,
        pcodeList: getPlanTargetListVO.pcodeList as Array<string>,
        itemCodeList: getPlanTargetListVO.itemCodeList as Array<string>,
      }
    ];

    if (PlessViewUtilsSub.isEmpty(getPlanTargetListVO.orderCode)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード'], () => { });
      return
    }
    if (PlessViewUtilsSub.isEmpty(getPlanTargetListVO.page)) {
      this.dialogService.openAlertGetMessage('W0001', ['表示ページ'], () => { });
      return
    }

    // 02. 選定候補一覧取得API呼び出し
    this.getPlanTargetListService.execute(this.parentModel, getPlanTargetListVO, planTargetList,
      (data: any) => this.parentModel.kymw1300Component.getPlanTargetListServiceSuccessFunc(data, getPlanTargetListVO));
  }

  /**
   * 選定候補一覧・ソート(データグリッドカラム)_クリック時に呼び出される
   *
   * @param {*} event
   * @param {FlexGrid} grid 処理対象データグリッド
   * @returns {void}
   * @memberof KYMW1300TargetListComponent
   */
  public eventSelectTargetList_HEADERRELEASEHandler(event: any, grid: FlexGrid): void {
    // 後続のデフォルトイベントをキャンセル
    event.preventDefault();

    if (grid.hitTest(event.pageX, event.pageY).cellType === CellType.Cell) {
      // データグリッド行の背景色設定処理
      this.setColorPattern(grid);
    }

    const field: string = this.selectTargetListField[grid.columns[grid.hitTest(event).col].binding];

    // イベント発生項目のチェック
    if (field === undefined                                                     // ソート対象項目ではない場合
      || PlessViewUtilsSub.isEmpty(field)) {
      // 処理復帰
      return;
    }

    // ソート可否判定処理
    if (!DataGridUtil.isSortable(event, grid)) {                                // ソート不可の場合
      // 処理復帰
      return;
    }

    let getPlanTargetListVO: KYMW1300GetPlanTargetListModel = null;

    getPlanTargetListVO = this.parentModel.setGetPlanTargetListVO(this.targetSetModel, null, Boolean(true));
    getPlanTargetListVO.page = '1';
    getPlanTargetListVO.sortItem = field;
    getPlanTargetListVO.sortOrder = DataGridUtil.switchHeaderText(event, grid);
    getPlanTargetListVO.focusFlg = '0';

    this.targetSetModel.sortItem = getPlanTargetListVO.sortItem;
    this.targetSetModel.sortOrder = getPlanTargetListVO.sortOrder;

    const planTargetList: PlanTargetList = [
      {
        guideGoodsName: getPlanTargetListVO.guideGoodsName as Array<string>,
        guideStandardName: getPlanTargetListVO.guideStandardName as Array<string>,
        tagId: getPlanTargetListVO.tagId as Array<string>,
        goodsMark: getPlanTargetListVO.goodsMark as Array<string>,
        coopCode: getPlanTargetListVO.coopCode as Array<string>,
        catalogCode: getPlanTargetListVO.catalogCode as Array<string>,
        pageNo: getPlanTargetListVO.pageNo as Array<string>,
        duties: getPlanTargetListVO.duties as Array<string>,
        pcodeList: getPlanTargetListVO.pcodeList as Array<string>,
        itemCodeList: getPlanTargetListVO.itemCodeList as Array<string>,
      }
    ];

    if (PlessViewUtilsSub.isEmpty(getPlanTargetListVO.orderCode)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード'], () => { });
      return
    }
    if (PlessViewUtilsSub.isEmpty(getPlanTargetListVO.page)) {
      this.dialogService.openAlertGetMessage('W0001', ['表示ページ'], () => { });
      return
    }

    // // 02. 選定候補一覧取得API呼び出し
    this.getPlanTargetListService.execute(this.parentModel, getPlanTargetListVO, planTargetList,
      (data: any) => this.parentModel.kymw1300Component.getPlanTargetListServiceSuccessFunc(data, getPlanTargetListVO));
  }

  /**
   * 選定候補一覧(データグリッド)_選択アイテム変更時_変更時に呼び出されるメソッド
   *
   * @param 
   * @memberof KYMW1300TargetListComponent
   */
  public eventSelectTarget_ITEMCLICKHandler(): void {
    let pCode: string = <string>'';
    const fromTargetList = 'targetList';
    if (!PlessViewUtilsSub.isEmptyArray(this.dg_SelectTargetList.selectedItems)) {
      pCode = this.dg_SelectTargetList.selectedItems[0].PCode;
    }

    // 行選択とロック状況のチェック
    if (!PlessViewUtilsSub.isEmpty(pCode)                                       // 行選択あり
      && PlessViewUtilsSub.isEmpty(this.parentModel.lockPCode)                  // 商品企画メンテナンス画面・ロック取得Ｐコードなし
      && !PlessViewUtilsSub.isEmpty(this.parentModel.lockPCode_KYMW0800)        // 実績履歴画面・ロック取得Ｐコードあり
      && this.parentModel.lockPCode_KYMW0800 !== pCode) {                       // 実績履歴画面・ロック取得Ｐコードと異なる場合
      // 排他ロック情報のリリース
      this.LockUtilForPlanGoods('RELEASE',
        this.parentModel.lockOrderCode, this.parentModel.lockMediumType, this.parentModel.lockPCode_KYMW0800,
        null, null,
        null, null,
        false);

      // ロック解除処理
      this.parentModel.kymw1300Component.deleteLockInfo(true);
    }

    // 実績履歴画面の起動状況のチェック
    if (this.isOpened('KYMW0800')) {                                            // 起動済みの場合
      const kymw0800vo: KYMW0800InputModel = this.parentModel.setKYMW0800InputVO(fromTargetList);
      kymw0800vo.funcID = 'KYMW1300L';

      // 選択行の内容で再表示
      this.parentModel.kymw1300Component.kymw0800cmp.setInputVO(kymw0800vo);
    }
  }

  /**
   * 選定候補一覧・選定(コンテキスト)_クリック時に呼び出されるメソッド
   *
   * @memberof KYMW1300TargetListComponent
   */
  public async eventRegistPlan_CLICKHandler(): Promise<boolean> {
    let grid: FlexGrid = null;
    grid = this.dg_SelectTargetList;

    // 07. 商品選定確認APIリクエストVO初期化処理
    const registPlanVO: KYMW1300RegistPlanModel = new KYMW1300RegistPlanModel();
    const checkregistPlanVO: KYMW1300CheckRegistPlanModel = new KYMW1300CheckRegistPlanModel();
    let filteredOrderCodeList: Array<any> = new Array<any>();
    const selectedMediumTypeList = this.parentModel.mediumTypeList.find(item => item.MediumType === this.parentModel.mediumType);

    //《束ねフラグが'0'(束ね企画対象外)の媒体が選択されているかつ、単企画回への選定にチェックが入っている》
    if (selectedMediumTypeList.BundleCatalogFlag === '0' && this.parentModel.radioGroup === '2') {
      checkregistPlanVO.orderCodeList.push(this.parentModel.orderCode);
      registPlanVO.orderCodeList.push(this.parentModel.orderCode);
    }
    // 《束ねフラグが'1'(束ね企画対象)の媒体が選択されているかつ、束ね企画回への選定にチェックが入っているかつ、
    // 　受注コードが入力されていない場合》
    if (selectedMediumTypeList.BundleCatalogFlag === '1' && this.parentModel.radioGroup === '1' && PlessViewUtilsSub.isEmpty(this.parentModel.orderCode)) {
      const selectedOrderCodeList = this.parentModel.selectedBundleCatalogRoundInfoList[0].BundleCatalogOrderCodeList;
      selectedOrderCodeList.forEach(item => {
        checkregistPlanVO.orderCodeList.push(item);
        registPlanVO.orderCodeList.push(item);
      });
    }
    //《束ね企画媒体が選択されているかつ、束ね企画回への選定にチェックが入っているかつ、
    //　受注コードが入力されている場合》
    if (selectedMediumTypeList.BundleCatalogFlag === '1' && this.parentModel.radioGroup === '1' && (!PlessViewUtilsSub.isEmpty(this.parentModel.orderCode))) {

      //入力された受注コード
      checkregistPlanVO.orderCodeList.push(this.parentModel.orderCode);
      registPlanVO.orderCodeList.push(this.parentModel.orderCode);
      if (PlessViewUtilsSub.isEmpty(this.parentModel.bundleCatalogGuideStandardName)) {
        this.dialogService.openAlertGetMessage('E0110', ['束ね企画名']);
        return false;
      } else {
        this.parentModel.selectedBundleCatalogRoundInfoList = this.parentModel.bundleCatalogRoundInfoList.filter(item => item.BundleCatalogRoundId === this.parentModel.BundleCatalogRoundId);
        this.parentModel.selectedBundleCatalogRoundInfoList.forEach(item => {
          filteredOrderCodeList = item.BundleCatalogOrderCodeList.filter(itemList => parseInt(itemList) > parseInt(this.parentModel.orderCode))
        })
        
        //入力されている受注コードから束ね企画回の終了受注コードまでの間の受注コード
        filteredOrderCodeList.forEach(item => {
          checkregistPlanVO.orderCodeList.push(item);
          registPlanVO.orderCodeList.push(item);
        });
      }

    }
    // 《束ねフラグが'1'(束ね企画対象)の媒体が選択されているかつ、単企画回への選定にチェックが入っている場合》
    if (selectedMediumTypeList.BundleCatalogFlag === '1' && this.parentModel.radioGroup === '2') {
      checkregistPlanVO.orderCodeList.push(this.parentModel.orderCode);
      registPlanVO.orderCodeList.push(this.parentModel.orderCode);
    }

    // 選定確認処理リクエスト用VO,選定処理リクエスト用VOにセット
    // 媒体区分
    if (PlessViewUtilsSub.isEmpty(this.parentModel.mediumType)) {
      this.dialogService.openAlertGetMessage('E0110', ['媒体区分']);
      return false;
    } else {
      checkregistPlanVO.mediumType = this.parentModel.mediumType;
      registPlanVO.mediumType = this.parentModel.mediumType;
    }
    // 売り場コード
    if (PlessViewUtilsSub.isEmpty(this.parentModel.kymw1300Component.cmb_SellArea.selectedSellAreaCode)) {
      this.dialogService.openAlertGetMessage('E0110', ['売り場']);
      return false;
    } else {
      checkregistPlanVO.sellAreaCode = this.parentModel.kymw1300Component.cmb_SellArea.selectedSellAreaCode;
      registPlanVO.sellAreaCode = this.parentModel.kymw1300Component.cmb_SellArea.selectedSellAreaCode;
    }
    //　注文コード割当コード
    if (PlessViewUtilsSub.isEmpty(this.parentModel.kymw1300Component.kymw1300_02.cmb_OrderNumQuota.selectedOrderNumQuotaCode)) {
      this.dialogService.openAlertGetMessage('E0110', ['注文コード割当']);
      return false;
    } else {
      checkregistPlanVO.orderNumQuotaCode = this.parentModel.kymw1300Component.kymw1300_02.cmb_OrderNumQuota.selectedOrderNumQuotaCode;
      registPlanVO.orderNumQuotaCode = this.parentModel.kymw1300Component.kymw1300_02.cmb_OrderNumQuota.selectedOrderNumQuotaCode;
    }
    //　特集コード
    checkregistPlanVO.featureCode = this.parentModel.featureCode;
    registPlanVO.featureCode = this.parentModel.featureCode;

    for (const item of grid.selectedItems) {
      if (PlessViewUtilsSub.isEmpty(item.PCode)) {
        this.dialogService.openAlertGetMessage('E0110', ['Ｐコード']);
        return false;
      } else {
        checkregistPlanVO.RegistPlanPCodeList.push(item.PCode);
        registPlanVO.pCodeList.push(item.PCode);
      }
    }

    if (!PlessViewUtilsSub.isEmpty(this.parentModel.bundleCatalogGuideStandardName)) {
      registPlanVO.bundleCatalogRoundId = this.parentModel.BundleCatalogRoundId;
    }

    // 選択している媒体が「03: クーポン媒体」もしくは「04: ポイント交換媒体」の場合、選定チェックを行う
    if (selectedMediumTypeList.MediumGroupDiv === '03' || selectedMediumTypeList.MediumGroupDiv === '04') {
      const errPCodes: string[] = [];
      for (const item of grid.selectedItems) {
        // 選定されていない場合
        if (item.Status === '' || item.Status === '0' || item.Status === '1') {
          errPCodes.push(item.PCode);
          continue;
        }

        const vo = new GetDeletePlanGoodsInfoModel();
        vo.orderCode = this.parentModel.orderCode;
        vo.pCode = item.PCode;
        vo.mediumType = selectedMediumTypeList.MediumType;

        try {
          const data = await this.execGetDeletePlanGoodsInfoAsync(vo);

          const mediumTypeList = data.DeletePlanGoodsTargetList.map((e) =>
            this.parentModel.mediumTypeList.find(m => m.MediumType === e.MediumType)
          );

          let result = [];
          if (selectedMediumTypeList.MediumGroupDiv === '03'){
            result = mediumTypeList
              .filter(m => m?.MediumGroupDiv === '01' || m?.MediumGroupDiv === '02' || m?.MediumGroupDiv === '05');
          } else {
            result = mediumTypeList
              .filter(m => m?.MediumGroupDiv === '01');
          }

          if (PlessViewUtilsSub.isEmptyArray(result)) {
            errPCodes.push(item.PCode);
          }
        } catch (err) {
          errPCodes.push(item.PCode);
        }
      }

      if (errPCodes.length > 0) {
        let errCode = '';
        if (selectedMediumTypeList.MediumGroupDiv === '03'){
          errCode = 'E0648';
        } else {
          errCode = 'E0649';
        }

        this.dialogService.openAlertGetMessage(errCode, [errPCodes.join(', ')]);
        return false;
      }
    }

    // 「選定」クリックフラグ
    this.parentModel.senteiFlg = '1';

    // 07. 商品選定確認API呼び出し
    this.checkRegistPlanService.execute(this.parentModel, checkregistPlanVO,
      (data: any) => this.parentModel.kymw1300Component.checkRegistPlanServiceSuccessFunc(data, registPlanVO));
  }

  private execGetDeletePlanGoodsInfoAsync(vo: GetDeletePlanGoodsInfoModel): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        // 第3引数の successFunc が呼ばれたら resolve
        this.getDeletePlanGoodsInfoService.execute(null, vo, (data: any) => {
          resolve(data);
        });
      } catch (e) {
        // execute 内で同期例外が出た場合
        reject(e);
      }
    });
  }

  /**
   * 選定候補一覧・選定済リストを検索(コンテキスト)_クリック時に呼び出されるメソッド
   *
   * @returns {void}
   * @memberof KYMW1300TargetListComponent
   */
  public eventSearchSelectedList_CLICKHandler(): void {
    let grid: FlexGrid = null;

    grid = this.dg_SelectTargetList;

    // 「選定」クリックフラグ
    this.parentModel.senteiFlg = '1';

    const pCode: string = grid.selectedItems[0].PCode;
    const mediumType: string = grid.selectedItems[0].MediumType;
    const sellAreaCode: string = grid.selectedItems[0].SellAreaCode;
    const classCode: string = grid.selectedItems[0].PlanClassCode;
    const middleClassCode: string = grid.selectedItems[0].PlanMiddleClassCode;
    const smallClassCode: string = grid.selectedItems[0].PlanSmallClassCode;

    this.parentModel.kymw1300Component.kymw1300_03.cmb_ClassCode.setClassCode(classCode);
    this.parentModel.kymw1300Component.kymw1300_03.cmb_MiddleClassCode.setMiddleClassCode(middleClassCode);
    this.parentModel.kymw1300Component.kymw1300_03.cmb_SmallClassCode.setSmallClassCode(smallClassCode);

    this.parentModel.kymw1300Component.kymw1300_03.setDispMode('1');

    // 注文コード割当コンボの初期化
    this.parentModel.kymw1300Component.kymw1300_03.cmb_OrderNumQuota_Selected.selectedIndex = 0;
    this.parentModel.kymw1300Component.kymw1300_03.cmb_OrderNumQuota_Selected.update();
    // 特集コード割当コンボの初期化
    this.parentModel.featureCode = '';

    // 媒体コンボボックスで選択中の媒体区分と選定候補一覧で選択した商品が選定されている媒体区分のチェック
    if (this.parentModel.mediumType === mediumType) {      // 同一媒体区分の場合
      // 売り場区分コンボで選択中の売り場区分と選定候補一覧で選択した商品の売り場区分のチェック
      if (this.parentModel.kymw1300Component.cmb_SellArea.selectedSellAreaCode !== sellAreaCode) {  // 異なる場合
        // 売り場区分コンボの再ロード
        this.parentModel.kymw1300Component.cmb_SellArea.setSellAreaCode(sellAreaCode);
      }
    } else {                                                                    // 上記以外の場合
      // 必須チェック：受注コード
      if (PlessViewUtilsSub.isEmpty(this.parentModel.orderCode)) {
        this.dialogService.openAlertGetMessage('W0001', ['受注コード'], () => { });
        return;
      }

      this.parentModel.mediumType = mediumType;
      let mediumInfo = this.parentModel.mediumTypeList.find(_ => _.MediumType === mediumType);

      // 単企画回を選択・活性にする
      this.parentModel.radioGroup = "2";
      this.parentModel.enabledSingleBundleCatalogRound = true;
      // 受注コードの背景は黄色
      this.parentModel.kymw1300Component.txt_OrderCode.required = true;
      
      // 束ね対象媒体の場合
      let isBundleCatalog: boolean = mediumInfo?.BundleCatalogFlag === "1";
      if (isBundleCatalog) this.getBundleCatalogRoundInfoListService.execute({mediumType: mediumType}, (data) => {
        this.parentModel.kymw1300Component.getBundleCatalogRoundInfoListServiceSuccessFunc(data);
      });
      this.parentModel.enabledBundleCatalogGuideStandardName = isBundleCatalog;   // 束ね媒体の場合、束ね企画名は活性
      
      // 売り場区分設定
      this.parentModel.kymw1300Component.cmb_SellArea.reload(mediumType, sellAreaCode);
      this.parentModel.kymw1300Component.cmb_SellArea.disabled = isBundleCatalog; // 束ね媒体の場合、売り場区分は非活性

      // 注文コード割当再取得
      this.parentModel.kymw1300Component.kymw1300_02.cmb_OrderNumQuota.mediumType = mediumType;
      this.parentModel.kymw1300Component.kymw1300_02.cmb_OrderNumQuota.reload();

      if (this.parentModel.isGroupNormalOrStock()) {
        this.parentModel.kymw1300Component.kymw1300_03.cmb_OrderNumQuota_Selected.mediumType = mediumType;
        this.parentModel.kymw1300Component.kymw1300_03.cmb_OrderNumQuota_Selected.selectedIndex = 0;
        this.parentModel.kymw1300Component.kymw1300_03.cmb_OrderNumQuota_Selected.reload();
      } else {
        this.parentModel.kymw1300Component.kymw1300_03.cmb_OrderNumQuota_Selected.clear();
      }

      // 特集コード割当再取得
      const getFeatureCodeVO = {
        orderCode: this.parentModel.orderCode,
        mediumType: mediumType
      }
      this.getFeatureCodeListService.execute(getFeatureCodeVO, (data) => {
        this.parentModel.kymw1300Component.getFeatureCodeListServiceSuccessFunc(data);
      });

      // 選定候補一覧のステータス
      this.targetSetModel.setStatus_Change(mediumType);

      // 選定候補一覧の背景色設定処理
      this.setColorPattern(this.dg_SelectTargetList);

      // 『バンドルミックスマッチ設定』画面の再表示を行う
      this.parentModel.kymw1300Component.refleshTargetWindow('KYMW1308');

      // 子画面の再表示を行う
      this.parentModel.kymw1300Component.refleshTargetWindow();

      // Pコード一発選定(メインメニュー)の活性制御を行う
      this.parentModel.kymw1300Component.setEnabledKYMW1304();

      // ヘッダー情報入力チェック(媒体：チェック要、売り場：チェック否)
      this.parentModel.kymw1300Component.checkInputHeader(true, false);

      // バンドルミックスマッチボタン活性制御
      this.parentModel.kymw1300Component.changeEnableBundleMixMatch();

      // デイリー媒体、スポット媒体時は非活性にする
      if (!this.parentModel.isDutiesFormWeekly()) {                             // ウィークリーでない場合
        // ボタンの活性・非活性制御
        this.plessEnabled(this.parentModel.kymw1300Component.kymw1300_03.btn_nextGuideBatchSet, false);   // 次回案件一括設定
        this.plessEnabled(this.parentModel.kymw1300Component.kymw1300_03.btn_nextGuideCheck, false);      // 次回案件チェック
      }

      // セット企画リスト出力(メインメニュー)、セット企画設定(メインメニュー)の活性制御
      this.parentModel.kymw1300Component.setEnabledSetPlanMenu();
    }

    // 05. 選定済一覧取得APIリクエストVO初期化処理
    const getSelectedListVO: KYMW1300GetSearchSelectedListModel = this.parentModel.setGetSelectedListVO();
    getSelectedListVO.mediumType = mediumType;
    getSelectedListVO.sellAreaCode = sellAreaCode;
    getSelectedListVO.classCode = classCode;
    getSelectedListVO.middleClassCode = middleClassCode;
    getSelectedListVO.smallClassCode = smallClassCode;
    getSelectedListVO.orderNumQuotaCode = '';
    getSelectedListVO.searchPCode = pCode;
    getSelectedListVO.focusFlg = '3';                                           // 表示モード・部門

    // 検索条件を保持しておき次回検索がページングの場合に利用する
    this.parentModel.lastTimeGetSelectedListVO = getSelectedListVO;

    // 05. 選定済一覧取得API呼び出し
    this.getSelectedListService.execute(this.parentModel, getSelectedListVO,
      (data: any) => this.parentModel.kymw1300Component.getSelectedListServiceSuccessFunc(data, getSelectedListVO));
  }

  /**
   * 選定候補一覧・履歴(コンテキスト)_クリック時に呼び出される
   *
   * @memberof KYMW1300TargetListComponent
   */
  public eventKYMW0800_CLICKHandler(): void {
    const fromTargetList = 'targetList';

    // 『実績履歴』画面を呼び出す
    const kymw0800vo: KYMW0800InputModel = this.parentModel.setKYMW0800InputVO(fromTargetList);

    kymw0800vo.funcID = 'KYMW1300L';

    this.parentModel.kymw1300Component.kymw0800ComponentRef =
      this.dialogService.openModelessSub(this.parentModel.kymw1300Component, KYMW0800Component,
        this.parentModel.kymw1300Component.viewContainerRef, this.parentModel.kymw1300Component.kymw0800ComponentRef, kymw0800vo, null, '', true);
    if (this.parentModel.kymw1300Component.kymw0800ComponentRef != null) {
      this.parentModel.kymw1300Component.kymw0800cmp =
        this.parentModel.kymw1300Component.kymw0800ComponentRef.instance as KYMW0800Component;
      this.parentModel.kymw1300Component.kymw0800cmp.setInterfaceParam(kymw0800vo);
      this.parentModel.kymw1300Component.kymw0800cmp.parent = this.parentModel.kymw1300Component;

      // 設定ボタン押下時の処理
      this.parentModel.kymw1300Component.kymw0800cmp.setKYMW0800Parameter =
        (kymw0800OutputVO: KYMW0800OutputModel) => this.parentModel.kymw1300Component.setKYMW0800Parameter(kymw0800OutputVO);

      // ウィンドウが閉じられる際の処理
      this.parentModel.kymw1300Component.kymw0800cmp.closeFunction = () => {
        this.parentModel.kymw1300Component.kymw0800ComponentRef.destroy();
        this.parentModel.kymw1300Component.kymw0800cmp = null;
        this.parentModel.kymw1300Component.checkLockChildClose();
      };
    }
  }

  /**
   * データグリッド「選定候補一覧」のキー項目を指定し該当行を選択状態にする。
   *
   * @param {FlexGrid} targetDg 対象データグリッド
   * @param {Array<any>} targetList 対象選定候補リスト
   * @param {string} targetPCode 選択対象Ｐコード
   * @memberof KYMW1300SelectedListComponent
   */
  public selectRowSelectTarget(targetDg: FlexGrid, targetList: Array<any>, targetPCode: string): void {

    // 行選択処理
    for (let i = Number(0); i < targetList.length; i++) {

      if (targetList[i].PCode === targetPCode) {                                // 同一Ｐコードの場合
        // 選択行を設定
        targetDg.select(i, -1);

        // ループ中断
        break;
      }
    }
  }


  /**
   * 注文コード割当コードコンボロード完了通知
   *
   * @param {string} code 選択注文コード割当コード
   * @memberof KYMW1300TargetListComponent
   */
  public orderNumQuotaLoadCompleted(code: string): void {
    this.parentModel.orderNumQuotaCode = code;
  }

  /**
   * 一覧表の高さ調整
   * @returns
   */
  public resizeFlexGrid(): void {
    // 表示切替が選定候補一覧＆選定済一覧の場合
    if (this.parentModel.cntDispChange === 1) {
      this.dg_SelectTargetList.hostElement.style.height = '324px';
      return
    }
    // 表示切替が選定候補一覧の場合
    this.dg_SelectTargetList.hostElement.style.height = 'calc(-366px + 100vh)';
  }
}
